export default {
  total: '共 {total} 條',
  page_size: '{size} 條/頁',
  goTo: '跳轉到',
  page: '頁',
};
